import { render, staticRenderFns } from "./InfoLink.vue?vue&type=template&id=1c85319c&"
import script from "./InfoLink.vue?vue&type=script&lang=ts&"
export * from "./InfoLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports